import { AppUserSettingService } from '@aca-new/app/shared/services/user-services/app-user-setting/app-user-setting.service';
import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class QimaSnapChecklistGuard implements CanActivate {
  private readonly _appUserSettingService: AppUserSettingService = inject(AppUserSettingService);
  private readonly _router: Router = inject(Router);

  /**
   * @description
   * Blocks checklist routes when QIMA Snap is enabled.
   * @returns {boolean} False when Snap is on (redirects to home); otherwise true.
   */
  public canActivate(): boolean {
    if (this._appUserSettingService.getIsQimaSnapEnabled()) {
      void this._router.navigate(['/']);

      return false;
    }

    return true;
  }
}
